import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, ListItemIcon } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Logout from "@mui/icons-material/Logout";
import "./index.scss";
import logo from "../../resources/logo.png";
import { clearOfflineData, getOfflineData } from "../../utils/offline-services";
import SideMenu from "../side-menu";
import { USER_ROLES } from "../../utils/roles";
import { redirectToIntranetPortal } from "../../utils/common-utils";
import Intranetlogout from "../../../../core/header/logout";
import { tokenMainKeys, appSlugs } from "../../../../utils/constants";

const Header = ({
  token = tokenMainKeys.invoiceTracking,
  slug = appSlugs.invoiceTracking,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    let user = getOfflineData("user", token);
    setUserDetails(user);
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    clearOfflineData("user", token);
    clearOfflineData("tokens", token);
    Intranetlogout(navigate);
  };
  return (
    <div className="header-container">
      <div className="logo-con">
        {userDetails?.role === USER_ROLES.admin && <SideMenu />}
      </div>
      {/* <div className="menu">
        <Avatar>
          <AccountCircleIcon />
        </Avatar>
        <Button
          type="small"
          variant="text"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {userDetails.name}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </div> */}
    </div>
  );
};

export default Header;
